import {
    PRESUPUESTADOR_GET_PRESUPUESTO_BEGIN,
    PRESUPUESTADOR_GET_PRESUPUESTO_SUCCESS,
    PRESUPUESTADOR_GET_PRESUPUESTO_FAILURE,
    PRESUPUESTADOR_GET_PRESUPUESTO_DISMISS_ERROR
} from './constants'
import { BFFAgent } from 'BFFAgent';
import { getEndpoint } from '../../common/backend/endpoints'
import axios from 'axios'
import history from '../../../common/history'

export function getPresupuesto(id_presupuesto, isEditMode = false) {
    return async (dispatch, getState) => {
        // optionally you can have getState as the second argument
        dispatch({
            type: PRESUPUESTADOR_GET_PRESUPUESTO_BEGIN
        })

        const endpoint = getEndpoint('PRESUPUESTADOR')
        const { presupuestador = {} } = getState()
        try {
            const { data: { data } } = await axios(`${endpoint}/${id_presupuesto}`)
            const  clientData = await BFFAgent.Clients.getCliente(data.client_id);
            const presupuesto = data
            presupuesto.costoPatentamiento = presupuesto.delivery_costs
            presupuesto.costoPatentamientoOriginal = presupuesto.delivery_costs_original
            if (!presupuesto.payments_methods) {
                presupuesto.payments_methods = []
            }
            const presupuesto_anterior = {
                delivery_costs: presupuesto.delivery_costs
            }
            let entregaUsados = await Promise.all(
              data.Taking_cars.map(async car => {
                if (car.license_plate) {
                  const { peritaje, peritajeQuote } = await BFFAgent.Peritador.getPeritaje(
                    car.license_plate,
                    false,
                    true
                  )
                    if (peritaje && peritajeQuote) {
                    car = {
                      ...car,
                      appraisal_approved: peritajeQuote.appraisal_approved,
                      locked: peritaje.locked,
                      presupuesto_reservado: peritaje.presupuesto_reservado,
                      recepcion_manual: peritaje.recepcion_manual,
                      ...(isEditMode
                        ? {
                            assessed: Number(peritaje.statusId),
                            original_price: peritajeQuote.appraisal,
                            brand: peritaje.verification.vehicle.brand.label,
                            model: peritaje.verification.vehicle.model.label,
                            version: peritaje.verification?.original_vehicle?.version?.label || peritaje.verification.vehicle.version.label,
                            versionId: peritaje.verification?.original_vehicle?.version?.value || peritaje.verification.vehicle.version.value,
                            year: peritaje.verification?.original_vehicle?.year?.label || peritaje.verification.vehicle.year.label,
                            mileage: peritaje.verification.original_kilometraje || peritaje.verification.kilometraje,
                            requestsId: peritaje.verification.requestsId,
                            take_improvement_amount: car.appraisal_was_modified ? 0 : car.take_improvement_amount,
                            updatedTakePrice: car.appraisal_was_modified ? null : car.updatedTakePrice,
                          }
                        : {}),
                    }
                  }
                }
                return {
                id: car.id,
                quotation_id: car.quotation_id,
                original_price: car.original_price,
                final_take_price: car.final_take_price || null,
                take_improvement_amount: car.take_improvement_amount,
                appraisal: car.appraisal,
                oldValue: car.final_take_price,
                peritado: car.assessed,
                year: car.year,
                brand: car.brand,
                model: car.model,
                version: car.version,
                versionId: car.version_id,
                patente: car.license_plate,
                verificationDate: car.verification_date
                    ? car.verification_date
                    : null,
                km: car.mileage,
                valid: true,
                pending: false,
                error: null,
                requestsId: car.requestsId ? car.requestsId : null,
                updatedTakePrice: Number(car.updatedTakePrice) || null,
                appraisal_approved: car.appraisal_approved,
                appraisal_was_modified: car.appraisal_was_modified,
                updatedTakePriceWasModified: Boolean(Number(car.updatedTakePrice)),
                locked: car.locked,
                presupuesto_reservado: car.presupuesto_reservado,
                recepcion_manual: car.recepcion_manual,
                }
              })
            )

            // Ocultamos solo los ya ingresados a gestión de usados (locked por recepción manual).
            // Los reservados en este presupuesto tienen locked=true pero deben seguir visibles.
            entregaUsados = entregaUsados.filter(
              car => !car.locked || car.presupuesto_reservado
            )
            if (
                history.action === 'POP' &&
                presupuestador.entregaUsados.length > 0
            ) {
                entregaUsados = presupuestador.entregaUsados
            }

            // desnormalizar data
            if (typeof presupuesto.reservation_credits === 'string') {
                presupuesto.reservation_credits = JSON.parse(
                    presupuesto.reservation_credits
                )
            }

            dispatch({
                type: PRESUPUESTADOR_GET_PRESUPUESTO_SUCCESS,
                data: {
                    ...data,
                    presupuestoGuardado: presupuesto,
                    id_presupuesto: presupuesto.id,
                    client_id: data.client_id,
                    cliente: {
                        id_cliente: data.client_id,
                        nombre: data.client_first_name,
                        apellido: data.client_last_name,
                        cuil_cuit: clientData.cuil_cuit,
                        zip_code: clientData.zip_code,
                        email: data.client_email,
                        telefono: data.client_telefono,
                        tipoDoc: data.client_doc_type,
                        documento: data.client_doc,
                        pais: data.client_pais,
                        provincia: data.client_provincia
                    },
                    test_drive: data.test_drive,
                    entregaUsados: entregaUsados,
                    presupuesto_anterior: presupuesto_anterior,
                    specialBonification: data.special_discount,
                    gastosDeEntrega: data.delivery_costs,
                    selectedStock: data.stock_id,
                    sumarCantidad: data.sale_quantity || 1,
                    tipoVentaSelected:
                        data.sale_type === 'DIRECTA'
                            ? 'venta_directa'
                            : 'venta_convencional'
                }
            })
        } catch (err) {
            dispatch({
                type: PRESUPUESTADOR_GET_PRESUPUESTO_FAILURE,
                data: { error: err }
            })
        }
    }

    // Use rejectHandler as the second argument so that render errors won't be caught.
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetPresupuestoError() {
    return {
        type: PRESUPUESTADOR_GET_PRESUPUESTO_DISMISS_ERROR
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case PRESUPUESTADOR_GET_PRESUPUESTO_BEGIN:
            // Just after a request is sent
            return {
                ...state,
                entregaUsados: [],
                getPresupuestoPending: true,
                getPresupuestoError: null
            }

        case PRESUPUESTADOR_GET_PRESUPUESTO_SUCCESS:
            // The request is success
            return {
                ...state,
                ...action.data,
                selectedStock: state.selectedStock
                    ? state.selectedStock
                    : action.data.selectedStock,
                cliente:
                    state.cliente && state.client_id_lead
                        ? state.cliente
                        : action.data.cliente,
                getPresupuestoPending: false,
                getPresupuestoError: null
            }

        case PRESUPUESTADOR_GET_PRESUPUESTO_FAILURE:
            // The request is failed
            return {
                ...state,
                getPresupuestoPending: false,
                getPresupuestoError: action.data.error
            }

        case PRESUPUESTADOR_GET_PRESUPUESTO_DISMISS_ERROR:
            // Dismiss the request failure error
            return {
                ...state,
                getPresupuestoError: null
            }

        default:
            return state
    }
}
